import { createAction, props } from '@ngrx/store';

import { RouteAreaType } from "../../types/route-area-type";

export const changeAreaAction = createAction('[Rotas] Notifica mudanças de rota', props<{ payload: { type: RouteAreaType, url: string } }>());
